import polyglotI18nProvider from 'ra-i18n-polyglot';
import en from 'ra-language-english';
import enMessages from './i18n/en';

export const i18nProvider = polyglotI18nProvider(() => ({ ...en, ...enMessages }), 'en', { allowMissing: true });
